import {socketIoUrl} from '../config/env'
import io from 'socket.io-client/dist/socket.io';
import {setLocVal,getLocVal} from "./util";
class WSocket  {
    constructor(visitorCode,opt) {
        this.socket = null;
        this.visitorCode=visitorCode
        this.isOffLineLogin = false
        this.lastActiveTime = this.getLastActiveTime();
        this.init();
        this.refreshLastActiveTime();
        this.webSocketHandleMessage = opt.webSocketHandleMessage;
        this.onconnect = opt.onconnect
        this.disconnect = opt.disconnect
        this.error = opt.error
        this.reconnect = opt.reconnect
    }

    init() {
        let _this = this;

        if (typeof WebSocket != 'undefined') {
            this.socket  = io(socketIoUrl,{transports:["websocket"]});
        }else{
            this.socket  = io(socketIoUrl);
        }

        _this.socket.on("connect",function(){
            console.info("socket连接成功");
            _this.onconnect();
            _this.visitorLog();
        });
        _this.socket.on("im",function(data){
            let res = JSON.parse(data)
            _this.webSocketHandleMessage(res);
        });
        _this.socket.on("disconnect",function(e){
            console.info("socket断开连接",e);
            _this.disconnect();
        })
        _this.socket.on("error",function(e){
            console.info("socket抛出异常",e)
            _this.error(e)
        })
        _this.socket.on("reconnect",function (e) {
            _this.isOffLineLogin = true;
            _this.reconnect(e)
        })

    }

    send(payload) {
        this.socket.emit("im",encodeURIComponent(payload));
    }

    close(){
        this.socket.close()
    }

    connect(){
        this.socket.connect()
    }

    //访客登录
    visitorLog(){
        //访客登录请求
        let _this=this;
        if(_this.isOffLineLogin){
            _this.lastActiveTime = this.getLastActiveTime();
        }
        var visitorLogin={
            //访客编号
            visitorCode:_this.visitorCode,
            //是否断线重连
            isOffLineLogin:_this.isOffLineLogin,
            companyId:window.utilConfig.enterpriseId
        }

        if(_this.lastActiveTime){
            visitorLogin['lastActiveTime'] = parseInt(_this.lastActiveTime/1000);
        }

        console.info('lastActiveTime',_this.lastActiveTime)

        // console.info('visitorLogin',visitorLogin);


        //访客登录
        let  params={
            //0代表访客登录
            type:0,
            data:JSON.stringify(visitorLogin)
        }
        this.send(JSON.stringify(params));
    }

    getLastActiveTime(){
        if(getLocVal('lastActiveTime')){
            return getLocVal('lastActiveTime');
        }
        var currentTime = new Date().getTime();
        setLocVal('lastActiveTime',currentTime,10000);
        return  null;
    }

    refreshLastActiveTime(){

        setInterval(function (){
            var currentTime = new Date().getTime();
            setLocVal('lastActiveTime',currentTime,10000);
            console.info('refreshActiveTime',currentTime)
        },1000*5)


    }


}

export default WSocket
